export default {"src":"/_next/static/media/seed.2d575fc0.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};